import React, { useEffect, useState } from 'react';
import axios from 'axios';
import StandardOrdersReceived from './StandardOrdersReceived';
import GroceryOrdersReceived from './GroceryOrdersReceived';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://vakra.co.in';

const OrdersReceived = () => {
  const [vendorType, setVendorType] = useState('');
  const [vendorId, setVendorId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token') || '';

    if (!token) {
      setError('Please login to view orders.');
      setLoading(false);
      return;
    }

    const fetchVendorDetails = async () => {
      try {
        setLoading(true);
        setError('');

        const res = await axios.get(`${BASE_URL}/api/products/get-vendor-id`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const nextVendorId = res?.data?.vendorId ?? null;
        const nextVendorType = String(res?.data?.vendorType || '').toLowerCase();

        setVendorId(nextVendorId);
        setVendorType(nextVendorType);
      } catch (err) {
        console.error('OrdersReceived wrapper error:', err);
        setError(
          err?.response?.data?.message ||
            err?.message ||
            'Failed to fetch vendor details.'
        );
      } finally {
        setLoading(false);
      }
    };

    fetchVendorDetails();
  }, []);

  if (loading) {
    return (
      <div style={styles.pageCenter}>
        <div style={styles.box}>
          <h2 style={styles.title}>Orders loading...</h2>
          <p style={styles.text}>Vendor details fetch ho rahe hain.</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={styles.pageCenter}>
        <div style={styles.box}>
          <h2 style={styles.title}>Unable to load orders</h2>
          <p style={styles.error}>{error}</p>
        </div>
      </div>
    );
  }

  if (vendorType === 'grocery') {
    return (
      <GroceryOrdersReceived
        vendorId={vendorId}
        vendorType={vendorType}
      />
    );
  }

  return (
    <StandardOrdersReceived
      vendorId={vendorId}
      vendorType={vendorType}
    />
  );
};

const styles = {
  pageCenter: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: '#f5f7fb',
  },
  box: {
    width: '100%',
    maxWidth: '520px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '18px',
    padding: '24px',
    boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)',
  },
  title: {
    margin: '0 0 8px',
    fontSize: '22px',
    fontWeight: 800,
    color: '#111827',
  },
  text: {
    margin: 0,
    fontSize: '14px',
    color: '#6b7280',
  },
  error: {
    margin: 0,
    fontSize: '14px',
    color: '#b91c1c',
    fontWeight: 600,
  },
};

export default OrdersReceived;
